<!-- start app-order-details -->
<div class="order_details" [ngClass]="ClassList">
    <span class="app_wrap_content label_lg_normal">
        <strong class="app_label">{{Data?.label}} : </strong>
        <span class="app_value mx-1" [innerHTML]="Data?.value"></span>        
    </span>
</div>
<!-- end app-order-details -->